var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepostClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170_127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1H2V23H24V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0834 2.8335L14.8334 5.5835M14.8334 5.5835L12.0834 8.3335M14.8334 5.5835H8.23337C6.69322 5.5835 5.92315 5.5835 5.3349 5.88322C4.81745 6.14687 4.39675 6.56757 4.1331 7.08501C3.83337 7.67328 3.83337 8.44334 3.83337 9.9835V15.2085C3.83337 15.6342 3.83337 15.847 3.8569 16.0258C4.01936 17.2597 4.99041 18.2309 6.22442 18.3933C6.40313 18.4168 6.61599 18.4168 7.0417 18.4168M11.1667 18.4168H17.7667C19.3068 18.4168 20.0769 18.4168 20.6652 18.117C21.1826 17.8534 21.6033 17.4327 21.8669 16.9153C22.1667 16.3271 22.1667 15.5569 22.1667 14.0168V8.79183C22.1667 8.36611 22.1667 8.15325 22.1431 7.97454C21.9808 6.74053 21.0096 5.76948 19.7757 5.60702C19.5969 5.5835 19.3841 5.5835 18.9584 5.5835M11.1667 18.4168L13.9167 21.1668M11.1667 18.4168L13.9167 15.6668",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepostClear);
export default __webpack_public_path__ + "static/media/repost-clear.21e91d6f6267bdddeb1eab596334799e.svg";
export { ForwardRef as ReactComponent };